import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { DistrictType, UpazilaType } from "../../../models";
import {
  getDistrictList,
  getDivisionList,
  getUpazilaList,
} from "../../../store/apis";
import {
  deleteNetaVideos,
  netaVideoListAction,
} from "../../../store/API/MemberApis";
import Table from "../../../components/common/TableComponent";
import Pagination from "../../../components/common/Pagination";

const NetaVideos = () => {
  const { netaVideoList } = useAppSelector((state) => state.member);

  const { division, district, upazila } = useAppSelector(
    (state) => state.common
  );

  // const [remountComponent, setRemountComponent] = useState(0);

  const [districtOprion, setDistrictOprion] = useState<DistrictType[]>([]);
  const [divisionValue, setDivisionValue] = useState("");
  const [districtValue, setDistricValue] = useState("");
  const [upazilaValue, setUpazilaValue] = useState("");
  const [upazilaOption, setUpazilaOption] = useState<UpazilaType[]>([]);
  const [selectedPage, setSelectedPage] = useState(1);

  const dispatch = useAppDispatch();
  const limit = 10;
  useEffect(() => {
    dispatch(
      netaVideoListAction({
        page: 1,
        page_size: limit,
      })
    );
    dispatch(getDivisionList());
    dispatch(getDistrictList());
    dispatch(getUpazilaList());
  }, [dispatch]);

  const handleDivisionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const filteredDistricts = district?.filter(
      (item: DistrictType) => item.division.id === parseInt(e.target.value)
    );
    setDistrictOprion(filteredDistricts);
    setDivisionValue(e.target.value);
    dispatch(
      netaVideoListAction({
        page: 1,
        page_size: limit,
        division: e.target.value,
      })
    );
  };

  const handleDistrictChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setDistricValue(e.target.value);

    const filteredUpazila = upazila.filter(
      (item: UpazilaType) => String(item.district.id) === e.target.value
    );

    setUpazilaOption(filteredUpazila);
    dispatch(
      netaVideoListAction({
        page: 1,
        page_size: limit,
        district: e.target.value,
      })
    );
  };

  const handleUpazilaChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setUpazilaValue(e.target.value);

    dispatch(
      netaVideoListAction({
        page: 1,
        page_size: limit,
        upazila: e.target.value,
      })
    );
  };

  const handlePageClick = (data: any) => {
    dispatch(
      netaVideoListAction({
        page: data.selected + 1,
        page_size: limit,
        district: districtValue,
        division: divisionValue,
        upazila: upazilaValue,
      })
    );
    setSelectedPage(data.selected + 1);
  };

  const columns = [
    { header: "Name", accessor: (item: any) => item?.member?.name || "" },
    { header: "Link", accessor: "link" },
    { header: "Video Type", accessor: "videoType" },
    // { header: "Type", accessor: "member_type" },
    // { header: "Neta", accessor: (item: any) => getAllMemberNames(item.member) },
  ];

  const handleNetaEdit = (item: any) => {
    const url = `/admin/neta/videos/edit/${item.id}`;
    window.open(url, "_blank"); // Opens the URL in a new tab
  };

  const handleDelete = (item: any) => {
    dispatch(
      deleteNetaVideos({
        id: item,
        page: selectedPage,
        page_size: limit,
        district: districtValue,
        division: divisionValue,
        upazila: upazilaValue,
      })
    );
  };
  return (
    <div className="flex flex-col gap-4 px-4 pt-6 text-start justify-center">
      <div className="m-3">
        <p className="text-center">Neta Videos</p>
        <div className="flex items-center">
          {/*  division select box*/}
          <div className="mx-2">
            <div className="flex justify-center">
              <div className="">
                <select
                  value={divisionValue}
                  onChange={handleDivisionChange}
                  className="form-shandleStatusChangeelect 
      text-gray-700
      bg-white 
      border border-solid border-gray-300
      rounded
      focus:ring-gray-900 focus:border-gray-900 h-11"
                  aria-label="Default select example"
                >
                  <option value="">Select Division</option>
                  {division?.map((item: any) => (
                    <option value={item.id}>{item?.name}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/*  Political select box*/}
          <div className="mx-2">
            <div className="flex justify-center">
              <div className="">
                <select
                  value={districtValue}
                  onChange={handleDistrictChange}
                  className="form-select 
      text-gray-700
      bg-white 
      border border-solid border-gray-300
      rounded
      focus:ring-gray-900 focus:border-gray-900 h-11"
                  aria-label="Default select example"
                >
                  <option value="">Select District</option>
                  {districtOprion?.map((item: any) => (
                    <option value={item.id}>{item?.name}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className="mx-2">
            <div className="flex justify-center">
              <div className="">
                <select
                  value={upazilaValue}
                  onChange={handleUpazilaChange}
                  className="form-select 
      text-gray-700
      bg-white 
      border border-solid border-gray-300
      rounded
      focus:ring-gray-900 focus:border-gray-900 h-11"
                  aria-label="Default select example"
                >
                  <option value="">Select District</option>
                  {upazilaOption?.map((item: any) => (
                    <option value={item.id}>{item?.name}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
        <Table
          columns={columns}
          data={netaVideoList?.results || []}
          onEdit={handleNetaEdit}
          onDelete={handleDelete}
          //   extraAction={handleApproveAmbassador}
        />
        <div className="mt-8 flex justify-end">
          <Pagination
            pageCount={
              netaVideoList?.count && Math.ceil(netaVideoList?.count / limit)
            }
            handlePageClick={handlePageClick}
            pageRange={2}
          />
        </div>
      </div>
    </div>
  );
};

export default NetaVideos;
